module.exports = __webpack_public_path__ + "static/media/atw_wichtelwuensche_schild.e6fb027e.svg";